var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uv-card"},[_c('div',{staticClass:"uv-card-body"},[_c('v-row',[_c('v-col',{attrs:{"md":"9","cols":"12"}},[_c('ModuleHeader',[_vm._v("Administrar aplicaciones")])],1)],1),_c('uv-data-table',{attrs:{"config":_vm.config,"data":_vm.apps,"pageRows":15},on:{"buttonClick":_vm.dtButtonClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }